import { Link } from 'react-router-dom';
import styles from './PageNotFound.module.css';

export function PageNotFound() {
  return (
    <main className={styles.page} id="main-content">
      <div className={styles.inner}>
        <p className={styles.code} aria-hidden="true">404</p>
        <h1 className={styles.heading}>Page Not Found</h1>
        <p className={styles.message}>
          The page you requested could not be found. Please check the URL or
          return to the home page.
        </p>
        <Link to="/" className={styles.homeLink}>
          Return to Home
        </Link>
      </div>
    </main>
  );
}
